module.exports = __webpack_public_path__ + "img/30ne.433b867e.svg";